export const actions = {
    SET_BUSINESS_OBJECT: "SET_BUSINESS_OBJECT",
};

export default (state =
                    {
                        businessObject: null,
                    }, action) => {

    state = { ...state };

    if (action.type === actions.SET_BUSINESS_OBJECT) {
        if (action.payload) {
            state.businessObject = {
                id: action.payload.id,
                name: action.payload.name,
            }
        } else {
            state.businessObject = null;
        }
        return state;
    } else {
        return state;
    }
};



// WEBPACK FOOTER //
// ./app/reducers/manageDataBusinessObject.ts